export default "__VITE_ASSET__kh$6Dk38__"